import React from 'react';
import {object} from 'yup';
import {AdminInput, AdminSwitch} from "../../../../../../../dumb/FormInputs";
import {FormFooter, FormWrapper} from "../../../../../../../dumb/FormHandlers";
import ConfigCard from "../../../../../../../dumb/AdminHelpers/AdminConfigs/components/ConfigCard";
import withState from "../../../../../../../../utils/withState";
import {DEFAULT_CURRENCY} from "../../../../../../../../constants/currencies";
import {DEFAULT_MERCHANT_ID} from "../../../../../../../../constants/ids";
import {apiAdminRetailerGet, apiAdminRetailerUpdate} from "../../../../../../../../api/admin/retailers";
import {string} from "yup";
import openPopupReset
  from "../../../../../../../dumb/AdminHelpers/AdminConfigs/components/TrxProcessingForm/utils/openPopupReset";
import Decimal from "decimal.js";

module.exports = withState((setState, self, onMount) => {

  self.state = {
    ...self.state,
    loading: true
  }

  onMount(() => {
    const id = self.props.userId;
    apiAdminRetailerGet({id}).then((res) => {
      const precentRaw = (res.merchant || {}).rolling_reserve_fraction || '0';
      const defaultPercent = new Decimal(precentRaw).times('100').toString();
      setState({defaultPercent, loading: false});
    });
  })

  return (state, props) => {
    if (state.loading) return <span />;

    return (
      <FormWrapper
        data={{percent: state.defaultPercent, reserve_enabled: !!state.defaultPercent && state.defaultPercent !== '0'}}
        schema={{default: object({
            percent: string().when(['reserve_enabled'], {
              is: (reserve_enabled) => !!reserve_enabled,
              then: () => (
                string()
                  .positiveNumber()
                  .test('max', 'Maximum 100%', (val) => Number(val) <= 100)
                  .integer()
                  .required()
              ),
              otherwise: () => string(),
            })
          }
        )}}
        onSubmit={({percent, reserve_enabled}) => {
          const rolling_reserve_fraction = reserve_enabled
            ? new Decimal(percent).dividedBy('100').toString()
            : '0';

          return (
            apiAdminRetailerUpdate({
              id: props.userId,
              merchant: {rolling_reserve_fraction}}
            )
          )
        }}
        disableFormAfterSubmit
      >{(formCtx) => {
        const {
          reserve_enabled: enabled
        } = formCtx.state.data;

        const inputProps = ({
          className: "(sl10)>.error-display",
          name: "percent",
          endAdornment: (
            <span className="w26 pv12 f16 o50">
              %
            </span>
          ),
          disableLabel: true
        })

        return (
          <>
            <ConfigCard className="layoutRow jcSB aiC mt24">
              <div className="w layoutRow jcSB aiC dB@m2">
                <div className="f12 lh18 fw7">
                  ROLLING RESERVE PERCENT
                </div>
                <div className="layoutRow">
                  <div className="mh48">
                    <AdminSwitch
                      label={enabled ? 'Enabled' : 'Disabled'}
                      name="reserve_enabled"
                      formCtx={formCtx}
                    />
                  </div>
                  <div className="wmax200 w (mt-10|mb-18)>.MuiFormControl-root (mt10)>.MuiFormControl-root@m2">
                    {enabled
                      ? (
                        <AdminInput
                          {...inputProps}
                          formCtx={formCtx}
                        />
                      ) : (
                        <AdminInput
                          {...inputProps}
                          value="0"
                          disabled
                        />
                      )
                    }
                  </div>
                </div>
              </div>
            </ConfigCard>
            <FormFooter
              className="mb25"
              submitBtnData={{
                text: 'Save Configuration',
                formCtx
              }}
            />
          </>
        )
      }}</FormWrapper>
    )
  }
});
